import {
  CommunicationPreferencesView,
  NotificationType,
  useCommunicationPreferencesViewCreator,
} from '@viewCreators/CommunicationPreferencesViewCreator';
import { useEffect, useState } from 'react';
import {
  RawCommunicationPreference,
  useSaveCommunicationPreferencesAction,
} from '@actions/SaveCommunicationPreferencesAction';
import { useNavigate } from 'react-router-dom';

export const usePreferencesController = () => {
  const { data, refetch, isLoading } = useCommunicationPreferencesViewCreator();
  const { mutateAsync: action } = useSaveCommunicationPreferencesAction();
  const [view, setView] = useState<CommunicationPreferencesView[]>([]);
  const [showAlert, setShowAlert] = useState<{ show: boolean; severity: 'success' | 'error' }>({
    show: false,
    severity: 'success',
  });
  const navigator = useNavigate();

  useEffect(() => {
    if (!isLoading && data) setView(data);
  }, [isLoading, data]);

  const onNotificationChanged = (
    e: React.ChangeEvent,
    value: { preferenceId: number; notificationType: NotificationType }
  ) => {
    for (const item of view) {
      if (item.id === value.preferenceId) {
        item.checked.email = value.notificationType === NotificationType.EMAIL;
        item.checked.push = value.notificationType === NotificationType.PUSH;
        item.checked.SMS = value.notificationType === NotificationType.SMS;
      }
    }
    setView([...view]);
  };

  const onSave = async () => {
    try {
      const raw = view.reduce((items, item, index) => {
        if (item.checked.email) {
          items.push({
            notificationPreferenceId: item.id,
            notificationTypeId: NotificationType.EMAIL,
          });
        }
        if (item.checked.push) {
          items.push({
            notificationPreferenceId: item.id,
            notificationTypeId: NotificationType.PUSH,
          });
        }
        if (item.checked.SMS) {
          items.push({
            notificationPreferenceId: item.id,
            notificationTypeId: NotificationType.SMS,
          });
        }

        return items;
      }, [] as RawCommunicationPreference[]);
      await action(raw);
      await refetch();
      setShowAlert({ show: true, severity: 'success' });
      setTimeout(() => setShowAlert({ show: false, severity: 'success' }), 3000);
    } catch (error) {
      setShowAlert({ show: true, severity: 'error' });
      setTimeout(() => setShowAlert({ show: false, severity: 'error' }), 3000);
    }
  };

  const onCancel = async () => {
    // Navigate back
    navigator(-1);
  };

  return {
    preferences: view,
    handleNotificationChanged: onNotificationChanged,
    handleSave: onSave,
    handleCancel: onCancel,
    showAlert,
  };
};
